// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 972) return "content/plugin-live-exploratory-viz/2ca611291d806ed16fb4dfb81d91a67c.js";
	// return url for filenames based on template
	return undefined;
};